import { downloadInternalAuditReportAttachment } from '../../../api/internalAudit';
import { InternalAuditReport } from '../../../types/internalAudit';
import ApprovalStampBox from '../ApprovalStampBox';
import '../../quality/EducationAnnualPlanTab.css';
import '../../quality/QualityShell.css';
import '../../product/InspectionFormSheet.css';
import '../../product/NonconformanceReportPanel.css';
import { PreviewAttachmentList } from './previewShared';

interface Props {
  detail: InternalAuditReport;
}

function InternalAuditReportPreviewView({ detail }: Props) {
  return (
    <div className="quality-form">
      <section className="quality-form__section">
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: 16,
            alignItems: 'flex-start',
            marginBottom: 12,
          }}
        >
          <h3 style={{ margin: 0 }}>심사 보고서</h3>
          <ApprovalStampBox
            authorName={detail.authorName}
            reviewerName={detail.reviewerName}
            approverName={detail.approverName}
          />
        </div>
        <div className="quality-form__grid">
          <label>
            보고서번호
            <input readOnly value={detail.reportNo || ''} />
          </label>
          <label>
            연결 계획서
            <input readOnly value={detail.planTitle || '-'} />
          </label>
          <label>
            연결 체크시트
            <input readOnly value={detail.checklistTitle || '-'} />
          </label>
          <label>
            심사일
            <input type="date" readOnly value={detail.auditDate || ''} />
          </label>
          <label>
            보고일
            <input type="date" readOnly value={detail.reportDate || ''} />
          </label>
          <label className="is-span-2">
            제목
            <input readOnly value={detail.title || ''} />
          </label>
          <label className="is-span-2">
            범위 요약
            <textarea rows={2} readOnly value={detail.scopeSummary || ''} />
          </label>
          <label className="is-span-2">
            심사팀
            <input readOnly value={detail.teamText || ''} />
          </label>
          <label>
            적합
            <input type="number" readOnly value={detail.conformCount ?? 0} />
          </label>
          <label>
            관찰(OFI)
            <input type="number" readOnly value={detail.ofiCount ?? 0} />
          </label>
          <label>
            부적합
            <input type="number" readOnly value={detail.ncCount ?? 0} />
          </label>
          <label className="is-span-2">
            주요 발견사항
            <textarea rows={4} readOnly value={detail.findingsText || ''} />
          </label>
          <label className="is-span-2">
            종합결론
            <textarea rows={3} readOnly value={detail.conclusion || ''} />
          </label>
          <label>
            시정조치 기한
            <input type="date" readOnly value={detail.followUpDue || ''} />
          </label>
          <label>
            NCR 연결(번호)
            <input readOnly value={detail.ncrRefs || ''} />
          </label>
          <label>
            피심사 확인
            <input readOnly value={detail.auditeeConfirm || ''} />
          </label>
          <label className="is-span-2">
            비고
            <textarea rows={2} readOnly value={detail.remark || ''} />
          </label>
        </div>
      </section>

      <section className="quality-form__section">
        <div className="edu-plan-card__title" style={{ marginBottom: 8 }}>
          <h3 style={{ margin: 0 }}>첨부파일</h3>
        </div>
        <PreviewAttachmentList
          files={detail.attachments}
          onDownload={(file) => {
            void downloadInternalAuditReportAttachment(
              detail.reportId,
              file.attachmentId,
              file.fileName
            );
          }}
        />
      </section>
    </div>
  );
}

export default InternalAuditReportPreviewView;
